<div class="d-flex justify-end b-16 mr-16">
    <div class="page-selector mr-16 align-items-center">
        <mat-form-field class="textWhite align-items-center mt-16" appearance="outline">
            <mat-select [(ngModel)]="pageSizeSelector" (ngModelChange)="handleSizeSelection($event)">
                <mat-option *ngFor="let item of pageSizesList" [value]="item">
                    {{ item }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="d-flex gap-10-px full-height">
        {{startingIndex}} - {{endingIdex}} de {{this.pageInfo.totalCount ?? 'x'}} resultados
        <div class="d-flex align-items-center gap-5-px">
            <sit-icon-button [icon]="Icon.first_page_arrow" (click)="setFirstPage()" [colorClass]="'text-white'"
                [alt]="'Ir a la primera página'" class="hover-arrow" />
            <sit-icon-button [icon]="Icon.backward" (click)="setPrevPage()" [colorClass]="'text-white'"
                [alt]="'Ir a la página anterior'" class="hover-arrow" />
            <sit-icon-button [icon]="Icon.forward" (click)="setNextPage()" [colorClass]="'text-white'"
                [alt]="'Ir a la siguiente página'" class="hover-arrow" />
            <sit-icon-button [icon]="Icon.last_page_arrow" (click)="setLastPage()" [colorClass]="'text-white'"
                [alt]="'Ir a la última página'" class="hover-arrow" />
        </div>
    </div>
</div>